import Router from 'next/router'
import { stringifyUrl } from 'query-string'

import { FILTERS_QUERY_PARAM } from '../../../brunswick/constants'
import { extractSelectedCollectionFilters } from '../../../lib/utils/collection-filters'

export function redirectLegacyFilterQueryParams({
  collectionFiltersQueryParam,
  collectionHandle,
  isPlainPageQueryParam,
  legacyCategoryQueryParam,
  legacyColorQueryParam,
  legacyFitQueryParam,
  pathname,
  res,
}: {
  collectionFiltersQueryParam: string | string[] | null | undefined
  collectionHandle: string
  isPlainPageQueryParam?: string | string[] | undefined
  legacyCategoryQueryParam: string | string[] | null | undefined
  legacyColorQueryParam: string | string[] | null | undefined
  legacyFitQueryParam: string | string[] | null | undefined
  pathname: string
  res:
    | {
        end(): void
        writeHead(httpStatus: number, headers: { Location: string }): void
      }
    | undefined
}): void {
  if (legacyCategoryQueryParam || legacyColorQueryParam || legacyFitQueryParam) {
    const selectedFilters: Record<string, string[]> = extractSelectedCollectionFilters({
      collectionFiltersQueryParam,
      legacyCategoryQueryParam,
      legacyColorQueryParam,
      legacyFitQueryParam,
    })

    const redirectPath: string = stringifyUrl({
      url: pathname.replace('[collectionHandle]', collectionHandle),
      query: {
        [FILTERS_QUERY_PARAM]: JSON.stringify(selectedFilters),
        ...(isPlainPageQueryParam !== undefined ? { plain: isPlainPageQueryParam } : {}),
      },
    })

    if (res) {
      // Server side redirect
      res.writeHead(301, { Location: redirectPath })
      res.end()
    } else {
      // Client side
      Router.replace(redirectPath)
    }
  }
}
